import React from 'react';
import styled from 'styled-components';
import { Input } from 'components/Form/Input';
import { SettingsGroup } from 'components/FormFields';

const Container = styled.div`
  padding-block: 20px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
  }
`;

const FeeSettingsCard = styled.div`
  background: ${(props) =>
    props.theme.name === 'dark' ? 'rgba(255, 255, 255, 0.03)' : '#ffffff'};
  border: 1px solid
    ${(props) =>
      props.theme.name === 'dark' ? 'rgba(255, 255, 255, 0.1)' : '#E2E8F0'};
  border-radius: 12px;
  padding: 20px;
`;

const FeeCardHeader = styled.div`
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 1px solid
    ${(props) =>
      props.theme.name === 'dark' ? 'rgba(255, 255, 255, 0.08)' : '#E2E8F0'};
`;

const FeeCardTitle = styled.h3`
  font-family: 'Barlow Condensed', sans-serif;
  font-size: 18px;
  font-weight: 700;
  margin: 0 0 4px 0;
  color: ${(props) =>
    props.theme.name === 'dark'
      ? props.theme.colors?.text?.primary || '#ffffff'
      : '#0F172A'};
`;

const FeeCardDescription = styled.p`
  font-size: 13px;
  margin: 0;
  color: ${(props) =>
    props.theme.name === 'dark'
      ? props.theme.colors?.textGray?.muted || '#64748B'
      : '#64748B'};
`;

const FeeInputsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const PointOfSaleSettings = ({
  handleChange,
  handleBlur,
  mainValues,
  handleMainChange,
}) => {
  const values = mainValues.pos_settings;

  const paymentOptions = [
    { label: 'Both', value: 'both' },
    { label: 'Cash', value: 'cash' },
    { label: 'Card', value: 'card' },
  ];

  const calculatorOptions = [
    { label: 'Yes', value: true },
    { label: 'No', value: false },
  ];

  const ticketDeliveryOptions = [
    { label: 'Mobile Delivery', value: 'mobile' },
    { label: 'Print from POS', value: 'print' },
    { label: 'Physical Tickets', value: 'physical' },
  ];

  const receiptDeliveryOptions = [
    { label: 'Mobile Delivery', value: 'mobile' },
    { label: 'Print from POS', value: 'print' },
    { label: 'Print from POS w/ Tickets', value: 'print_w_tickets' },
    { label: 'None', value: 'none' },
  ];

  const handleSettingChange = (settingName) => (event) => {
    handleChange({
      target: {
        name: settingName,
        value: event.target.value,
      },
    });
  };

  return (
    <Container>
      <SettingsGroup
        title="Accepted Payment Methods"
        description="Control which payment methods are available"
        name="payment"
        options={paymentOptions}
        value={values?.payment}
        onChange={handleSettingChange('payment')}
      />

      <SettingsGroup
        title="Show Cash Change Calculator"
        description="Display calculator when processing cash payments"
        name="calculator"
        options={calculatorOptions}
        value={values?.calculator}
        onChange={handleSettingChange('calculator')}
      />

      <SettingsGroup
        title="Ticket Delivery"
        description="How tickets are delivered to customers"
        name="ticket_delivery"
        options={ticketDeliveryOptions}
        value={values?.ticket_delivery}
        onChange={handleSettingChange('ticket_delivery')}
      />

      <SettingsGroup
        title="Receipt Delivery"
        description="How receipts are delivered to customers"
        name="receipt_delivery"
        options={receiptDeliveryOptions}
        value={values?.receipt_delivery}
        onChange={handleSettingChange('receipt_delivery')}
      />

      {handleMainChange && (
        <FeeSettingsCard>
          <FeeCardHeader>
            <FeeCardTitle>Default Fee Settings</FeeCardTitle>
            <FeeCardDescription>
              Configure default POS fee settings
            </FeeCardDescription>
          </FeeCardHeader>
          <FeeInputsContainer>
            <Input
              id="pos_fee_dollar"
              name="pos_fee_dollar"
              label="Dollar Amount (POS)"
              onChange={handleMainChange}
              onBlur={handleBlur}
              value={mainValues?.pos_fee_dollar ?? ''}
            />

            <Input
              id="pos_fee_percent"
              name="pos_fee_percent"
              label="Fee Percent (POS)"
              onChange={handleMainChange}
              onBlur={handleBlur}
              value={mainValues?.pos_fee_percent ?? ''}
            />
          </FeeInputsContainer>
        </FeeSettingsCard>
      )}
    </Container>
  );
};
